module.exports = __webpack_public_path__ + "img/energyManage.b24f985e.svg";